module.exports = __webpack_public_path__ + "img/stones@2x.d3ce001.webp";